<template>
  <div class="prodfile-list">
    <Toolbar :handle-add="addHandler" v-if="userHasAccess('prodfile_edit')"/>

    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex sm12>
          <h1><v-icon large>mdi-file-powerpoint</v-icon>{{$t('prodfile.prodfiles')}}</h1>
        </v-flex>
        <v-flex lg12>
          <DataFilter :handle-filter="onSendFilter" :handle-reset="resetFilter">
            <ProdFileFilterForm
                ref="filterForm"
                :values="filters"
                slot="filter"
            />
          </DataFilter>

          <br />

          <v-data-table
              v-model="selected"
              :headers="headers"
              :items="items"
              :items-per-page.sync="options.itemsPerPage"
              :footer-props="footer"
              :loading="isLoading"
              :loading-text="$t('global.loading')"
              :options.sync="options"
              :server-items-length="totalItems"
              class="elevation-1"
              item-key="@id"
              @click:row="showHandler"
              @contextmenu:row="showHandlerExt"
              @update:options="onUpdateOptions"
          >
            <template slot="item.quantity" slot-scope="{ item }">
              {{ $n(item['quantity']) }}
            </template>
            <template slot="item.timeExecution" slot-scope="{ item }">
              {{ $n(item['timeExecution']) }}
            </template>
            <template slot="item.materialConsumed" slot-scope="{ item }">
              {{ $n(item['materialConsumed']) }}
            </template>


          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import ListMixin from '../../mixins/ListMixin';

import ProdFileFilterForm from '../../components/prodfile/Filter';
import DataFilter from '../../components/DataFilter';
import Toolbar from '../../components/Toolbar';
import AccessMixin from '../../mixins/AccessMixin';

export default {
  name: 'ProdFileList',
  servicePrefix: 'ProdFile',
  mixins: [ListMixin,AccessMixin],
  components: {
    Toolbar,

    ProdFileFilterForm,
    DataFilter
  },
  data() {
    return {
      headers: [
        { text: this.$t('global.name'), value: 'name' },
        { text: this.$t('prodfile.designfile'), value: 'designFile.name' },
        { text: this.$t('machine.machine'), value: 'machine.name' },
        { text: this.$t('tool.tool'), value: 'tool.name' },
        { text: this.$t('printingsurface.printingsurface'), value: 'surface.name' },
        { text: this.$t('material.material'), value: 'material.name' },
        { text: this.$t('nozzle.nozzle'), value: 'nozzle.name' },
        { text: this.$t('global.createdby'), value: 'createdBy.login' },
        { text: this.$t('prodfile.comment'), value: 'comment', sortable: false}

      ],
      selected: [],
      footer: {
        'itemsPerPageText': "",
      },
      options: {sortBy : ['name'], sortDesc : [false]}
    };
  },
  computed: {
    ...mapGetters('prodfile', {
      items: 'list'
    }),
    ...mapFields('prodfile', {
      deletedItem: 'deleted',
      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    })
  },
  methods: {
    ...mapActions('prodfile', {
      getPage: 'fetchAll',
      deleteItem: 'del'
    })
  }
};
</script>
